import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import logger from 'donor-elf-web/lib/logger';

/*
  attrs
    - contact
    - group
    - onRemovedFromGroup(contact)
*/

export default class GroupContactRow extends Component {
  @service contactsCache;
  @service fundsService;

  @tracked removing = false;

  @action
  async remove() {
    this.removing = true;

    const { contact, group, onRemovedFromGroup } = this.args;
    const index = contact.groups.indexOf(group);

    if (index !== -1) {
      contact.groups.splice(index, 1);
    }

    try {
      await this.fundsService.confirmValidFundToken();
      await contact.save();
      this.contactsCache.incrementProperty('groupsCacheIndex');
      onRemovedFromGroup?.(contact);
    } catch (error) {
      logger.error(error);
    }
  }
}
